import { GetterTree } from 'vuex'

import { RootState, RecommendState } from '@/types/store'

export const getters: GetterTree<RecommendState, RootState> = {
  recommends(state): RecommendState['recommends'] {
    return state.recommends
  },
  isRecommendsLoading(state): RecommendState['isRecommendsLoading'] {
    return state.isRecommendsLoading
  },
}
